<template>
  <div class="app__wrapper" :class="{'has-opened-modal' : isShown}">
    <transition name="fade">
      <popup v-if="isShown" :mode="popupMode" @close="hideModal">
        <popup-langs slot="content" v-if="isModalLangs" />
        <popup-back
          slot="content"
          v-if="isModalBack"
          @handleClick="hideModal"
        />
      </popup>
    </transition>

    <top-bar @clickBack="showModalBack" @clickLangs="showModalLangs"
             :class="{ 'has-bg': window.width < 1000 && scrollPosition > 50 }"
             :style="{ backgroundColor : window.width < 1000 && scrollPosition > 50 ? topBarBg : 'transparent' }"/>
    <router-view />
  </div>
</template>

<script>
import { mixin } from '../mixin';
import topBar from './components/topBar.vue';
import Popup from './components/popup.vue';
import popupLangs from './components/popupLangs.vue';
import popupBack from './components/popupBack.vue';

export default {
  name: 'App',
  mixins: [mixin],
  components: {
    Popup,
    topBar,
    popupLangs,
    popupBack,
  },
  data() {
    return {
      scrollPosition: null,
      popupMode: '',
      isShown: false,
      isModalBack: false,
      isModalLangs: false,
    };
  },
  computed: {
    topBarBg() {
      return this.$route.meta.bg;
    },
  },
  mounted() {
    if (window) {
      window.addEventListener('scroll', this.updateScroll);
    }
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    showModalBack() {
      this.popupMode = 'theme';
      this.isShown = true;
      this.isModalBack = true;
      this.scrollHide();
    },
    showModalLangs() {
      this.popupMode = 'theme';
      this.isShown = true;
      this.isModalLangs = true;
      this.scrollHide();
    },
    hideModal() {
      this.popupMode = '';
      this.isShown = false;
      this.isModalBack = false;
      this.isModalLangs = false;
      this.scrollShow();
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
  transition: opacity 600ms;
}
</style>
